import { defineComponent, computed, inject, onMounted, onBeforeUnmount, withDirectives, createElementBlock, openBlock, unref, createElementVNode, renderSlot, vShow } from 'vue';
import { tabsInjectionKey } from './basler-components.es385.js';

const _hoisted_1 = ["id", "aria-labelledby", "tabindex"];
const _hoisted_2 = { class: "tab-panel__content" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabPanel",
  props: {
    uid: {},
    title: {},
    subtitle: { default: "" },
    imgSrc: { default: "" },
    activeOnInit: { type: Boolean, default: false },
    icon: {},
    badge: {}
  },
  setup(__props) {
    const props = __props;
    const computedId = props.uid || Date.now().toString(36) + Math.random().toString(36).substring(2);
    const isActive = computed(() => {
      if (!tabsState) {
        return false;
      }
      return tabsState.tabs.find((tab) => tab.computedId === computedId && tab.isActive);
    });
    const { tabsState, addTab, deleteTab } = inject(tabsInjectionKey) || {};
    onMounted(() => {
      if (addTab) {
        addTab({
          title: props.title,
          subtitle: props.subtitle,
          computedId,
          imgSrc: props.imgSrc,
          isActive: props.activeOnInit || false,
          icon: props.icon || void 0,
          badge: props.badge || void 0
        });
      }
    });
    onBeforeUnmount(() => {
      if (deleteTab) {
        deleteTab(computedId);
      }
    });
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", {
        id: `tab-panel-${unref(computedId)}`,
        role: "region",
        class: "tab-panel",
        "aria-labelledby": `tab-item-${unref(computedId)}`,
        tabindex: isActive.value ? 0 : void 0
      }, [
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "default")
        ])
      ], 8, _hoisted_1)), [
        [vShow, isActive.value]
      ]);
    };
  }
});

export { _sfc_main as default };
